import { Component, computed, inject, ChangeDetectionStrategy } from "@angular/core";
import { CommonCollapsibleCardWidget } from "@eforall/common";
import { ReadonlyAccessWidget } from "../../../readonly-access/readonly-access.widget";
import { VolunteerDialogDataService } from "../volunteer-dialog-data.service";
import { EditVolunteerStatusDialogPart } from "./edit-volunteer-status/edit-volunteer-status-dialog.part";
import { ListVolunteerStatusLogsPart } from "./list-volunteer-status-logs/list-volunteer-status-logs.part";
import { DomainDataService } from "../../../../../services";
import { MapExpertiseTopics } from "@interfaces";

@Component({
	selector: 'volunteer-application-status-log-dialog-part',
	standalone: true,
	imports: [
		EditVolunteerStatusDialogPart,
		ListVolunteerStatusLogsPart,
		ReadonlyAccessWidget,
		CommonCollapsibleCardWidget
	],
	templateUrl: './status-log-dialog.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './status-log-dialog.part.scss'
})

export class VolunteerStatusLogDialogPart {

	private readonly domainData = inject(DomainDataService);
	public dialogDataService = inject(VolunteerDialogDataService);
	public readonly expertises = computed(() => {
		const volunteer = this.dialogDataService.volunteerDetails();
		if (!volunteer) return [];
		const expertises = volunteer.expertises
			.map(e => {
				const expertise = this.domainData.data().expertisesMap[e];
				const topicIds = MapExpertiseTopics[e];
				const topics = topicIds?.map((topicId: number) => this.domainData.data().topicsMap[topicId]?.name)
					.filter((name: string | undefined): name is string => Boolean(name)) || [];

				return {
					id: e,
					name: expertise?.name,
					topics: topics
				}
			})
			.filter(expertise => expertise.name);
		return expertises;
	});
	public readonly isLeadVolunteer = computed(() => this.dialogDataService.isLeadVolunteer());
}